export class ResetPasswordRequest {
    public email!: string;
    public resetCode!: string;
    public password!: string;
}
